import { io } from "socket.io-client";

const BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:5000";

// Create socket but don't auto-connect.
// The httpOnly auth cookie rides along on the handshake (withCredentials).
export const socket = io(BASE, {
  autoConnect: false,
  withCredentials: true,
  transports: ["websocket"],
  // Resilient auto-reconnect so realtime features recover from network blips
  // without a manual refresh.
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 8000,
  timeout: 10000,
});

// Quiet diagnostics so connection problems are observable in dev but never
// spam the console or surface as uncaught errors in production.
socket.on("connect_error", (err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn("[socket] connect_error:", err?.message || err);
  }
});

// Kept as a no-op for backward compatibility: auth now travels via the
// httpOnly cookie, so there is no token to set on the client.
export function setSocketAuthToken() {}
